import React, { useMemo } from "react";
import Popover from "@mui/material/Popover";
import { Card, CardContent, Box, CardActions } from "@mui/material";
import Buttons from "../../../library/custom/button/Button";
import FormLabels from "../../../library/custom/formLabel/FormLabels";
import SelectMenu from "../../../library/custom/selectMenu/SelectMenu";
import "./FilterCommonStatusSelect.scss";
import MultiSelectBox from "../../../library/custom/selectMenu/MultiSelectBoxJha";
import { MAPPED, INSPECTION_SUBMIT_TYPE } from "../../../constant/constant";
import { sortAlphabetically } from "../../../utils/helper";

const UserFilterList = ({
  id,
  open,
  anchorEl,
  handleClose,
  firstLebelFilter,
  secondLebelFilter,
  firstLabel,
  secondLabel,
  firstLebelOnChanges,
  secondLebelOnChanges,
  firstLebelValue,
  secondLebelValue,
  resetBtn = false,
  handleClear,
  handleApply,
  isShow = false,
  expirationType,
  expirationTypeOnChanges,
  expirationTypeList = null,
  lmsTypeList = false, // report multi select
  USER_TRAININGS_TYPE_LMS_DASHBOARD,
  lmsTypeOnChanges,
  trainingType,
  yesnoshow = false,
  yesnoOnChanges,
  yesno,
  division,
  divisionOnChanges,
  divisionList,
  InspectionSubmitTypeShowshow = false,
  InspectionSubmitTypeOnChanges,
  inspectionSubmitType,
  thirdLebelFilter,
  thirdLabel,
  thirdLebelOnChanges,
  thirdLebelValue,
}) => {
  const sortedSecondLebelFilter = useMemo(() => {
    return sortAlphabetically(secondLebelFilter);
  }, [secondLebelFilter]);

  const sortedFirstLebelFilter = useMemo(() => {
    return sortAlphabetically(firstLebelFilter);
  }, [firstLebelFilter]);

  const sortedMapped = useMemo(() => {
    return sortAlphabetically(MAPPED);
  }, [MAPPED]);

  const sortedExpirationTypeList = useMemo(() => {
    return sortAlphabetically(expirationTypeList);
  }, [expirationTypeList]);

  const sortedDivisionList = useMemo(() => {
    return sortAlphabetically(divisionList);
  }, [divisionList]);

  const sortedThirdLebelFilter = useMemo(() => {
    return sortAlphabetically(thirdLebelFilter);
  }, [thirdLebelFilter]);

  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Card className="filterlist_of_cases">
          <CardContent>
            {secondLebelFilter && (
              <Box className="custom_filter_box" sx={{ pb: 2 }}>
                <FormLabels label={secondLabel} isRequired={false} />
                <SelectMenu
                  name={secondLabel}
                  listData={sortedSecondLebelFilter ?? []}
                  onchangehandler={(e) => secondLebelOnChanges(e)}
                  value={secondLebelValue}
                  placeholder="Please select"
                />
              </Box>
            )}
            {firstLebelFilter && isShow && (
              <Box className="">
                <FormLabels label={firstLabel} isRequired={false} />
                <SelectMenu
                  name={firstLabel}
                  listData={sortedFirstLebelFilter}
                  onchangehandler={(e) => firstLebelOnChanges(e)}
                  value={firstLebelValue}
                  placeholder="Please select"
                />
              </Box>
            )}
            {expirationTypeList && (
              <Box className="" sx={{ pb: 2, pt: 2 }}>
                <FormLabels label={"Expiry"} isRequired={false} />
                <SelectMenu
                  name={"expirationType"}
                  listData={sortedExpirationTypeList}
                  onchangehandler={(e) => expirationTypeOnChanges(e)}
                  value={expirationType}
                  placeholder="Please select"
                />
              </Box>
            )}

            {divisionList && (
              <Box className="">
                <FormLabels label={"Division"} isRequired={false} />
                <SelectMenu
                  name={"division"}
                  listData={sortedDivisionList}
                  onchangehandler={(e) => divisionOnChanges(e)}
                  value={division}
                  placeholder="Please select"
                />
              </Box>
            )}

            {lmsTypeList && (
              <Box>
                <FormLabels label={"Training Type"} isRequired={false} />
                <MultiSelectBox
                  placeholder={"Please Select"}
                  listData={USER_TRAININGS_TYPE_LMS_DASHBOARD}
                  onChange={(e) => lmsTypeOnChanges(e)}
                  value={trainingType || []}
                  editMode={false}
                  addclientpage={true}
                />
              </Box>
            )}
            {yesnoshow && (
              <Box sx={{ pb: 2, pt: 2 }}>
                <FormLabels label={"Verified Email"} isRequired={false} />
                <SelectMenu
                  name={"verifiedemail"}
                  listData={sortedMapped}
                  onchangehandler={(e) => yesnoOnChanges(e)}
                  value={yesno}
                  placeholder="Please select"
                />
              </Box>
            )}
            {InspectionSubmitTypeShowshow && (
              <Box sx={{ pb: 0, pt: 2 }}>
                <FormLabels
                  label={"Inspection Submit Type"}
                  isRequired={false}
                />
                <SelectMenu
                  name={"inspectionSubmitType"}
                  listData={INSPECTION_SUBMIT_TYPE}
                  onchangehandler={(e) => InspectionSubmitTypeOnChanges(e)}
                  value={inspectionSubmitType ?? ""}
                  placeholder="Please select"
                />
              </Box>
            )}
            {thirdLebelFilter && isShow && (
              <Box sx={{ pb: 0, pt: 1 }}>
                <FormLabels label={thirdLabel} isRequired={false} />
                <SelectMenu
                  name={thirdLabel}
                  listData={sortedThirdLebelFilter}
                  onchangehandler={(e) => thirdLebelOnChanges(e)}
                  value={thirdLebelValue}
                  placeholder="Please select"
                />
              </Box>
            )}
          </CardContent>
          <CardActions>
            {resetBtn && (
              <Buttons
                primary={true}
                label={"Reset"}
                onClick={(e) => handleClear(e)}
                size="small"
              />
            )}

            {/* <Buttons
              primary={true}
              label={"Reset"}
              onClick={(e) => resetFilter(e)}
              size="small"
            /> */}
            <Buttons
              primary={true}
              label={"Apply"}
              onClick={(e) => handleApply(e)}
              size="small"
            />
          </CardActions>
        </Card>
      </Popover>
    </>
  );
};

export default UserFilterList;
